export const FETCH_QUESTION_PENDING = 'FETCH_QUESTION_PENDING';
export const FETCH_QUESTION_REJECTED = 'FETCH_QUESTION_REJECTED';
export const FETCH_QUESTION_FULFILLED = 'FETCH_QUESTION_FULFILLED';
export const CLEAR_FETCH_QUESTION = 'CLEAR_FETCH_QUESTION';



// WEBPACK FOOTER //
// ./src/constants/itemQuestions.js